import _, { useMemo as V } from "react";
import q from "../../../../_virtual/isNil.js";
import { clsx as Z } from "../../../clsx/dist/clsx.js";
import { isNumOrStr as D, isNumber as I } from "../util/DataUtils.js";
import { Global as tt } from "../util/Global.js";
import { filterProps as rt } from "../util/ReactUtils.js";
import { getStringSize as G } from "../util/DOMUtils.js";
import { reduceCSSCalc as B } from "../util/ReduceCSSCalc.js";
var et = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], nt = ["dx", "dy", "angle", "className", "breakAll"];
function R() {
  return R = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R.apply(this, arguments);
}
function U(e, t) {
  if (e == null) return {};
  var r = at(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (a = 0; a < l.length; a++)
      n = l[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function at(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function z(e, t) {
  return ct(e) || ot(e, t) || lt(e, t) || it();
}
function it() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lt(e, t) {
  if (e) {
    if (typeof e == "string") return M(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return M(e, t);
  }
}
function M(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function ot(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, l, c, s = [], o = !0, h = !1;
    try {
      if (l = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        o = !1;
      } else for (; !(o = (n = l.call(r)).done) && (s.push(n.value), s.length !== t); o = !0) ;
    } catch (f) {
      h = !0, a = f;
    } finally {
      try {
        if (!o && r.return != null && (c = r.return(), Object(c) !== c)) return;
      } finally {
        if (h) throw a;
      }
    }
    return s;
  }
}
function ct(e) {
  if (Array.isArray(e)) return e;
}
var J = /[ \f\n\r\t\v\u2028\u2029]+/, K = function(t) {
  var r = t.children, n = t.breakAll, a = t.style;
  try {
    var l = [];
    q(r) || (n ? l = r.toString().split("") : l = r.toString().split(J));
    var c = l.map(function(o) {
      return {
        word: o,
        width: G(o, a).width
      };
    }), s = n ? 0 : G(" ", a).width;
    return {
      wordsWithComputedWidth: c,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, st = function(t, r, n, a, l) {
  var c = t.maxLines, s = t.children, o = t.style, h = t.breakAll, f = I(c), v = s, g = function() {
    var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return y.reduce(function(u, d) {
      var m = d.word, T = d.width, C = u[u.length - 1];
      if (C && (a == null || l || C.width + T + n < Number(a)))
        C.words.push(m), C.width += T + n;
      else {
        var Q = {
          words: [m],
          width: T
        };
        u.push(Q);
      }
      return u;
    }, []);
  }, W = g(r), N = function(y) {
    return y.reduce(function(u, d) {
      return u.width > d.width ? u : d;
    });
  };
  if (!f)
    return W;
  for (var E = "…", k = function(y) {
    var u = v.slice(0, y), d = K({
      breakAll: h,
      style: o,
      children: u + E
    }).wordsWithComputedWidth, m = g(d), T = m.length > c || N(m).width > Number(a);
    return [T, m];
  }, x = 0, i = v.length - 1, b = 0, S; x <= i && b <= v.length - 1; ) {
    var A = Math.floor((x + i) / 2), F = A - 1, P = k(F), H = z(P, 2), w = H[0], j = H[1], $ = k(A), L = z($, 1), p = L[0];
    if (!w && !p && (x = A + 1), w && p && (i = A - 1), !w && p) {
      S = j;
      break;
    }
    b++;
  }
  return S || W;
}, X = function(t) {
  var r = q(t) ? [] : t.toString().split(J);
  return [{
    words: r
  }];
}, ut = function(t) {
  var r = t.width, n = t.scaleToFit, a = t.children, l = t.style, c = t.breakAll, s = t.maxLines;
  if ((r || n) && !tt.isSsr) {
    var o, h, f = K({
      breakAll: c,
      children: a,
      style: l
    });
    if (f) {
      var v = f.wordsWithComputedWidth, g = f.spaceWidth;
      o = v, h = g;
    } else
      return X(a);
    return st({
      breakAll: c,
      children: a,
      maxLines: s,
      style: l
    }, o, h, r, n);
  }
  return X(a);
}, Y = "#808080", bt = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, l = a === void 0 ? 0 : a, c = t.lineHeight, s = c === void 0 ? "1em" : c, o = t.capHeight, h = o === void 0 ? "0.71em" : o, f = t.scaleToFit, v = f === void 0 ? !1 : f, g = t.textAnchor, W = g === void 0 ? "start" : g, N = t.verticalAnchor, E = N === void 0 ? "end" : N, k = t.fill, x = k === void 0 ? Y : k, i = U(t, et), b = V(function() {
    return ut({
      breakAll: i.breakAll,
      children: i.children,
      maxLines: i.maxLines,
      scaleToFit: v,
      style: i.style,
      width: i.width
    });
  }, [i.breakAll, i.children, i.maxLines, v, i.style, i.width]), S = i.dx, A = i.dy, F = i.angle, P = i.className, H = i.breakAll, w = U(i, nt);
  if (!D(n) || !D(l))
    return null;
  var j = n + (I(S) ? S : 0), $ = l + (I(A) ? A : 0), L;
  switch (E) {
    case "start":
      L = B("calc(".concat(h, ")"));
      break;
    case "middle":
      L = B("calc(".concat((b.length - 1) / 2, " * -").concat(s, " + (").concat(h, " / 2))"));
      break;
    default:
      L = B("calc(".concat(b.length - 1, " * -").concat(s, ")"));
      break;
  }
  var p = [];
  if (v) {
    var O = b[0].width, y = i.width;
    p.push("scale(".concat((I(y) ? y / O : 1) / O, ")"));
  }
  return F && p.push("rotate(".concat(F, ", ").concat(j, ", ").concat($, ")")), p.length && (w.transform = p.join(" ")), /* @__PURE__ */ _.createElement("text", R({}, rt(w, !0), {
    x: j,
    y: $,
    className: Z("recharts-text", P),
    textAnchor: W,
    fill: x.includes("url") ? Y : x
  }), b.map(function(u, d) {
    var m = u.words.join(H ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ _.createElement("tspan", {
        x: j,
        dy: d === 0 ? L : s,
        key: "".concat(m, "-").concat(d)
      }, m)
    );
  }));
};
export {
  bt as Text
};
